/** @namespace AlgoliaInsights */
import { useState, useEffect } from 'react'
import {
  recordAlgoliaClick,
  recordAlgoliaConversion,
  recordAlgoliaImpression
} from './helper'
import { isSSR } from '../../utils/ssrUtils'

/**
 * Check to see if an element is visible to the user. It only checks to
 *
 * @memberof KevelAnaylytics
 * @param {string} [blogImage] If this is present, we skip because
 * we do not care about blog impressions.
 */
const useHook = () => {
  // Create random uuid for each user
  // Only run this if we are not in SSR

  const ssrUserId = ''

  if (!isSSR()) {
    const initialUserID = localStorage?.getItem('uID') ?? ssrUserId
    const [userID, setUserID] = useState(initialUserID)

    useEffect(() => {
      try {
        if (!userID) {
          let uID = ''
          if (typeof crypto !== 'undefined') {
            uID = crypto.randomUUID()
          }
          setUserID(uID)
        }
      } catch (e) {
        console.log(e)
      }
    }, [])

    return {
      userID,
      recordAlgoliaClick: recordAlgoliaClick,
      recordAlgoliaConversion,
      recordAlgoliaImpression
    }
  }
  return {
    userID: ssrUserId,
    recordAlgoliaClick: recordAlgoliaClick,
    recordAlgoliaConversion,
    recordAlgoliaImpression
  }
}

export default useHook
